import React, { useState, useEffect, useRef } from 'react';

const countriesData = [
  { "code": "AF", "name": "Afghanistan", "nationality": "Afghan", "phoneCode": "+93" },
  { "code": "AL", "name": "Albania", "nationality": "Albanian", "phoneCode": "+355" },
  { "code": "DZ", "name": "Algeria", "nationality": "Algerian", "phoneCode": "+213" },
  { "code": "AD", "name": "Andorra", "nationality": "Andorran", "phoneCode": "+376" },
  { "code": "AO", "name": "Angola", "nationality": "Angolan", "phoneCode": "+244" },
  { "code": "AG", "name": "Antigua and Barbuda", "nationality": "Antiguan", "phoneCode": "+1-268" },
  { "code": "AR", "name": "Argentina", "nationality": "Argentinian", "phoneCode": "+54" },
  { "code": "AM", "name": "Armenia", "nationality": "Armenian", "phoneCode": "+374" },
  { "code": "AU", "name": "Australia", "nationality": "Australian", "phoneCode": "+61" },
  { "code": "AT", "name": "Austria", "nationality": "Austrian", "phoneCode": "+43" },
  { "code": "AZ", "name": "Azerbaijan", "nationality": "Azerbaijani", "phoneCode": "+994" },
  { "code": "BS", "name": "Bahamas", "nationality": "Bahamian", "phoneCode": "+1-242" },
  { "code": "BH", "name": "Bahrain", "nationality": "Bahraini", "phoneCode": "+973" },
  { "code": "BD", "name": "Bangladesh", "nationality": "Bangladeshi", "phoneCode": "+880" },
  { "code": "BB", "name": "Barbados", "nationality": "Barbadian", "phoneCode": "+1-246" },
  { "code": "BY", "name": "Belarus", "nationality": "Belarusian", "phoneCode": "+375" },
  { "code": "BE", "name": "Belgium", "nationality": "Belgian", "phoneCode": "+32" },
  { "code": "BZ", "name": "Belize", "nationality": "Belizean", "phoneCode": "+501" },
  { "code": "BJ", "name": "Benin", "nationality": "Beninese", "phoneCode": "+229" },
  { "code": "BT", "name": "Bhutan", "nationality": "Bhutanese", "phoneCode": "+975" },
  { "code": "BO", "name": "Bolivia", "nationality": "Bolivian", "phoneCode": "+591" },
  { "code": "BA", "name": "Bosnia and Herzegovina", "nationality": "Bosnian", "phoneCode": "+387" },
  { "code": "BW", "name": "Botswana", "nationality": "Botswanan", "phoneCode": "+267" },
  { "code": "BR", "name": "Brazil", "nationality": "Brazilian", "phoneCode": "+55" },
  { "code": "BN", "name": "Brunei", "nationality": "Bruneian", "phoneCode": "+673" },
  { "code": "BG", "name": "Bulgaria", "nationality": "Bulgarian", "phoneCode": "+359" },
  { "code": "BF", "name": "Burkina Faso", "nationality": "Burkinabe", "phoneCode": "+226" },
  { "code": "BI", "name": "Burundi", "nationality": "Burundian", "phoneCode": "+257" },
  { "code": "CV", "name": "Cabo Verde", "nationality": "Cabo Verdean", "phoneCode": "+238" },
  { "code": "KH", "name": "Cambodia", "nationality": "Cambodian", "phoneCode": "+855" },
  { "code": "CM", "name": "Cameroon", "nationality": "Cameroonian", "phoneCode": "+237" },
  { "code": "CA", "name": "Canada", "nationality": "Canadian", "phoneCode": "+1" },
  { "code": "CF", "name": "Central African Republic", "nationality": "Central African", "phoneCode": "+236" },
  { "code": "TD", "name": "Chad", "nationality": "Chadian", "phoneCode": "+235" },
  { "code": "CL", "name": "Chile", "nationality": "Chilean", "phoneCode": "+56" },
  { "code": "CN", "name": "China", "nationality": "Chinese", "phoneCode": "+86" },
  { "code": "CO", "name": "Colombia", "nationality": "Colombian", "phoneCode": "+57" },
  { "code": "KM", "name": "Comoros", "nationality": "Comoran", "phoneCode": "+269" },
  { "code": "CG", "name": "Congo", "nationality": "Congolese", "phoneCode": "+242" },
  { "code": "CD", "name": "DR Congo", "nationality": "Congolese", "phoneCode": "+243" },
  { "code": "CR", "name": "Costa Rica", "nationality": "Costa Rican", "phoneCode": "+506" },
  { "code": "CI", "name": "Cote d'Ivoire", "nationality": "Ivorian", "phoneCode": "+225" },
  { "code": "HR", "name": "Croatia", "nationality": "Croatian", "phoneCode": "+385" },
  { "code": "CU", "name": "Cuba", "nationality": "Cuban", "phoneCode": "+53" },
  { "code": "CY", "name": "Cyprus", "nationality": "Cypriot", "phoneCode": "+357" },
  { "code": "CZ", "name": "Czech Republic", "nationality": "Czech", "phoneCode": "+420" },
  { "code": "DK", "name": "Denmark", "nationality": "Danish", "phoneCode": "+45" },
  { "code": "DJ", "name": "Djibouti", "nationality": "Djiboutian", "phoneCode": "+253" },
  { "code": "DM", "name": "Dominica", "nationality": "Dominican", "phoneCode": "+1-767" },
  { "code": "DO", "name": "Dominican Republic", "nationality": "Dominican", "phoneCode": "+1-809" },
  { "code": "EC", "name": "Ecuador", "nationality": "Ecuadorian", "phoneCode": "+593" },
  { "code": "EG", "name": "Egypt", "nationality": "Egyptian", "phoneCode": "+20" },
  { "code": "SV", "name": "El Salvador", "nationality": "Salvadoran", "phoneCode": "+503" },
  { "code": "GQ", "name": "Equatorial Guinea", "nationality": "Equatorial Guinean", "phoneCode": "+240" },
  { "code": "ER", "name": "Eritrea", "nationality": "Eritrean", "phoneCode": "+291" },
  { "code": "EE", "name": "Estonia", "nationality": "Estonian", "phoneCode": "+372" },
  { "code": "SZ", "name": "Eswatini", "nationality": "Swazi", "phoneCode": "+268" },
  { "code": "ET", "name": "Ethiopia", "nationality": "Ethiopian", "phoneCode": "+251" },
  { "code": "FJ", "name": "Fiji", "nationality": "Fijian", "phoneCode": "+679" },
  { "code": "FI", "name": "Finland", "nationality": "Finnish", "phoneCode": "+358" },
  { "code": "FR", "name": "France", "nationality": "French", "phoneCode": "+33" },
  { "code": "GA", "name": "Gabon", "nationality": "Gabonese", "phoneCode": "+241" },
  { "code": "GM", "name": "Gambia", "nationality": "Gambian", "phoneCode": "+220" },
  { "code": "GE", "name": "Georgia", "nationality": "Georgian", "phoneCode": "+995" },
  { "code": "DE", "name": "Germany", "nationality": "German", "phoneCode": "+49" },
  { "code": "GH", "name": "Ghana", "nationality": "Ghanaian", "phoneCode": "+233" },
  { "code": "GR", "name": "Greece", "nationality": "Greek", "phoneCode": "+30" },
  { "code": "GD", "name": "Grenada", "nationality": "Grenadian", "phoneCode": "+1-473" },
  { "code": "GT", "name": "Guatemala", "nationality": "Guatemalan", "phoneCode": "+502" },
  { "code": "GN", "name": "Guinea", "nationality": "Guinean", "phoneCode": "+224" },
  { "code": "GW", "name": "Guinea-Bissau", "nationality": "Bissau-Guinean", "phoneCode": "+245" },
  { "code": "GY", "name": "Guyana", "nationality": "Guyanese", "phoneCode": "+592" },
  { "code": "HT", "name": "Haiti", "nationality": "Haitian", "phoneCode": "+509" },
  { "code": "HN", "name": "Honduras", "nationality": "Honduran", "phoneCode": "+504" },
  { "code": "HU", "name": "Hungary", "nationality": "Hungarian", "phoneCode": "+36" },
  { "code": "IS", "name": "Iceland", "nationality": "Icelandic", "phoneCode": "+354" },
  { "code": "IN", "name": "India", "nationality": "Indian", "phoneCode": "+91" },
  { "code": "ID", "name": "Indonesia", "nationality": "Indonesian", "phoneCode": "+62" },
  { "code": "IR", "name": "Iran", "nationality": "Iranian", "phoneCode": "+98" },
  { "code": "IQ", "name": "Iraq", "nationality": "Iraqi", "phoneCode": "+964" },
  { "code": "IE", "name": "Ireland", "nationality": "Irish", "phoneCode": "+353" },
  { "code": "IL", "name": "Israel", "nationality": "Israeli", "phoneCode": "+972" },
  { "code": "IT", "name": "Italy", "nationality": "Italian", "phoneCode": "+39" },
  { "code": "JM", "name": "Jamaica", "nationality": "Jamaican", "phoneCode": "+1-876" },
  { "code": "JP", "name": "Japan", "nationality": "Japanese", "phoneCode": "+81" },
  { "code": "JO", "name": "Jordan", "nationality": "Jordanian", "phoneCode": "+962" },
  { "code": "KZ", "name": "Kazakhstan", "nationality": "Kazakhstani", "phoneCode": "+7" },
  { "code": "KE", "name": "Kenya", "nationality": "Kenyan", "phoneCode": "+254" },
  { "code": "KI", "name": "Kiribati", "nationality": "I-Kiribati", "phoneCode": "+686" },
  { "code": "KW", "name": "Kuwait", "nationality": "Kuwaiti", "phoneCode": "+965" },
  { "code": "KG", "name": "Kyrgyzstan", "nationality": "Kyrgyzstani", "phoneCode": "+996" },
  { "code": "LA", "name": "Laos", "nationality": "Laotian", "phoneCode": "+856" },
  { "code": "LV", "name": "Latvia", "nationality": "Latvian", "phoneCode": "+371" },
  { "code": "LB", "name": "Lebanon", "nationality": "Lebanese", "phoneCode": "+961" },
  { "code": "LS", "name": "Lesotho", "nationality": "Basotho", "phoneCode": "+266" },
  { "code": "LR", "name": "Liberia", "nationality": "Liberian", "phoneCode": "+231" },
  { "code": "LY", "name": "Libya", "nationality": "Libyan", "phoneCode": "+218" },
  { "code": "LI", "name": "Liechtenstein", "nationality": "Liechtensteiner", "phoneCode": "+423" },
  { "code": "LT", "name": "Lithuania", "nationality": "Lithuanian", "phoneCode": "+370" },
  { "code": "LU", "name": "Luxembourg", "nationality": "Luxembourger", "phoneCode": "+352" },
  { "code": "MG", "name": "Madagascar", "nationality": "Malagasy", "phoneCode": "+261" },
  { "code": "MW", "name": "Malawi", "nationality": "Malawian", "phoneCode": "+265" },
  { "code": "MY", "name": "Malaysia", "nationality": "Malaysian", "phoneCode": "+60" },
  { "code": "MV", "name": "Maldives", "nationality": "Maldivian", "phoneCode": "+960" },
  { "code": "ML", "name": "Mali", "nationality": "Malian", "phoneCode": "+223" },
  { "code": "MT", "name": "Malta", "nationality": "Maltese", "phoneCode": "+356" },
  { "code": "MH", "name": "Marshall Islands", "nationality": "Marshallese", "phoneCode": "+692" },
  { "code": "MR", "name": "Mauritania", "nationality": "Mauritanian", "phoneCode": "+222" },
  { "code": "MU", "name": "Mauritius", "nationality": "Mauritian", "phoneCode": "+230" },
  { "code": "MX", "name": "Mexico", "nationality": "Mexican", "phoneCode": "+52" },
  { "code": "FM", "name": "Micronesia", "nationality": "Micronesian", "phoneCode": "+691" },
  { "code": "MD", "name": "Moldova", "nationality": "Moldovan", "phoneCode": "+373" },
  { "code": "MC", "name": "Monaco", "nationality": "Monegasque", "phoneCode": "+377" },
  { "code": "MN", "name": "Mongolia", "nationality": "Mongolian", "phoneCode": "+976" },
  { "code": "ME", "name": "Montenegro", "nationality": "Montenegrin", "phoneCode": "+382" },
  { "code": "MA", "name": "Morocco", "nationality": "Moroccan", "phoneCode": "+212" },
  { "code": "MZ", "name": "Mozambique", "nationality": "Mozambican", "phoneCode": "+258" },
  { "code": "MM", "name": "Myanmar", "nationality": "Burmese", "phoneCode": "+95" },
  { "code": "NA", "name": "Namibia", "nationality": "Namibian", "phoneCode": "+264" },
  { "code": "NR", "name": "Nauru", "nationality": "Nauruan", "phoneCode": "+674" },
  { "code": "NP", "name": "Nepal", "nationality": "Nepalese", "phoneCode": "+977" },
  { "code": "NL", "name": "Netherlands", "nationality": "Dutch", "phoneCode": "+31" },
  { "code": "NZ", "name": "New Zealand", "nationality": "New Zealander", "phoneCode": "+64" },
  { "code": "NI", "name": "Nicaragua", "nationality": "Nicaraguan", "phoneCode": "+505" },
  { "code": "NE", "name": "Niger", "nationality": "Nigerien", "phoneCode": "+227" },
  { "code": "NG", "name": "Nigeria", "nationality": "Nigerian", "phoneCode": "+234" },
  { "code": "KP", "name": "North Korea", "nationality": "North Korean", "phoneCode": "+850" },
  { "code": "MK", "name": "North Macedonia", "nationality": "Macedonian", "phoneCode": "+389" },
  { "code": "NO", "name": "Norway", "nationality": "Norwegian", "phoneCode": "+47" },
  { "code": "OM", "name": "Oman", "nationality": "Omani", "phoneCode": "+968" },
  { "code": "PK", "name": "Pakistan", "nationality": "Pakistani", "phoneCode": "+92" },
  { "code": "PW", "name": "Palau", "nationality": "Palauan", "phoneCode": "+680" },
  { "code": "PS", "name": "Palestine", "nationality": "Palestinian", "phoneCode": "+970" },
  { "code": "PA", "name": "Panama", "nationality": "Panamanian", "phoneCode": "+507" },
  { "code": "PG", "name": "Papua New Guinea", "nationality": "Papua New Guinean", "phoneCode": "+675" },
  { "code": "PY", "name": "Paraguay", "nationality": "Paraguayan", "phoneCode": "+595" },
  { "code": "PE", "name": "Peru", "nationality": "Peruvian", "phoneCode": "+51" },
  { "code": "PH", "name": "Philippines", "nationality": "Filipino", "phoneCode": "+63" },
  { "code": "PL", "name": "Poland", "nationality": "Polish", "phoneCode": "+48" },
  { "code": "PT", "name": "Portugal", "nationality": "Portuguese", "phoneCode": "+351" },
  { "code": "QA", "name": "Qatar", "nationality": "Qatari", "phoneCode": "+974" },
  { "code": "RO", "name": "Romania", "nationality": "Romanian", "phoneCode": "+40" },
  { "code": "RU", "name": "Russia", "nationality": "Russian", "phoneCode": "+7" },
  { "code": "RW", "name": "Rwanda", "nationality": "Rwandan", "phoneCode": "+250" },
  { "code": "KN", "name": "Saint Kitts and Nevis", "nationality": "Kittitian", "phoneCode": "+1-869" },
  { "code": "LC", "name": "Saint Lucia", "nationality": "Saint Lucian", "phoneCode": "+1-758" },
  { "code": "VC", "name": "Saint Vincent", "nationality": "Vincentian", "phoneCode": "+1-784" },
  { "code": "WS", "name": "Samoa", "nationality": "Samoan", "phoneCode": "+685" },
  { "code": "SM", "name": "San Marino", "nationality": "Sammarinese", "phoneCode": "+378" },
  { "code": "ST", "name": "Sao Tome and Principe", "nationality": "Sao Tomean", "phoneCode": "+239" },
  { "code": "SA", "name": "Saudi Arabia", "nationality": "Saudi", "phoneCode": "+966" },
  { "code": "SN", "name": "Senegal", "nationality": "Senegalese", "phoneCode": "+221" },
  { "code": "RS", "name": "Serbia", "nationality": "Serbian", "phoneCode": "+381" },
  { "code": "SC", "name": "Seychelles", "nationality": "Seychellois", "phoneCode": "+248" },
  { "code": "SL", "name": "Sierra Leone", "nationality": "Sierra Leonean", "phoneCode": "+232" },
  { "code": "SG", "name": "Singapore", "nationality": "Singaporean", "phoneCode": "+65" },
  { "code": "SK", "name": "Slovakia", "nationality": "Slovak", "phoneCode": "+421" },
  { "code": "SI", "name": "Slovenia", "nationality": "Slovenian", "phoneCode": "+386" },
  { "code": "SB", "name": "Solomon Islands", "nationality": "Solomon Islander", "phoneCode": "+677" },
  { "code": "SO", "name": "Somalia", "nationality": "Somali", "phoneCode": "+252" },
  { "code": "ZA", "name": "South Africa", "nationality": "South African", "phoneCode": "+27" },
  { "code": "KR", "name": "South Korea", "nationality": "South Korean", "phoneCode": "+82" },
  { "code": "SS", "name": "South Sudan", "nationality": "South Sudanese", "phoneCode": "+211" },
  { "code": "ES", "name": "Spain", "nationality": "Spanish", "phoneCode": "+34" },
  { "code": "LK", "name": "Sri Lanka", "nationality": "Sri Lankan", "phoneCode": "+94" },
  { "code": "SD", "name": "Sudan", "nationality": "Sudanese", "phoneCode": "+249" },
  { "code": "SR", "name": "Suriname", "nationality": "Surinamese", "phoneCode": "+597" },
  { "code": "SE", "name": "Sweden", "nationality": "Swedish", "phoneCode": "+46" },
  { "code": "CH", "name": "Switzerland", "nationality": "Swiss", "phoneCode": "+41" },
  { "code": "SY", "name": "Syria", "nationality": "Syrian", "phoneCode": "+963" },
  { "code": "TJ", "name": "Tajikistan", "nationality": "Tajikistani", "phoneCode": "+992" },
  { "code": "TZ", "name": "Tanzania", "nationality": "Tanzanian", "phoneCode": "+255" },
  { "code": "TH", "name": "Thailand", "nationality": "Thai", "phoneCode": "+66" },
  { "code": "TL", "name": "Timor-Leste", "nationality": "Timorese", "phoneCode": "+670" },
  { "code": "TG", "name": "Togo", "nationality": "Togolese", "phoneCode": "+228" },
  { "code": "TO", "name": "Tonga", "nationality": "Tongan", "phoneCode": "+676" },
  { "code": "TT", "name": "Trinidad and Tobago", "nationality": "Trinidadian", "phoneCode": "+1-868" },
  { "code": "TN", "name": "Tunisia", "nationality": "Tunisian", "phoneCode": "+216" },
  { "code": "TR", "name": "Turkey", "nationality": "Turkish", "phoneCode": "+90" },
  { "code": "TM", "name": "Turkmenistan", "nationality": "Turkmen", "phoneCode": "+993" },
  { "code": "TV", "name": "Tuvalu", "nationality": "Tuvaluan", "phoneCode": "+688" },
  { "code": "UG", "name": "Uganda", "nationality": "Ugandan", "phoneCode": "+256" },
  { "code": "UA", "name": "Ukraine", "nationality": "Ukrainian", "phoneCode": "+380" },
  { "code": "AE", "name": "United Arab Emirates", "nationality": "Emirati", "phoneCode": "+971" },
  { "code": "GB", "name": "United Kingdom", "nationality": "British", "phoneCode": "+44" },
  { "code": "US", "name": "United States", "nationality": "American", "phoneCode": "+1" },
  { "code": "UY", "name": "Uruguay", "nationality": "Uruguayan", "phoneCode": "+598" },
  { "code": "UZ", "name": "Uzbekistan", "nationality": "Uzbekistani", "phoneCode": "+998" },
  { "code": "VU", "name": "Vanuatu", "nationality": "Ni-Vanuatu", "phoneCode": "+678" },
  { "code": "VA", "name": "Vatican City", "nationality": "Vatican", "phoneCode": "+379" },
  { "code": "VE", "name": "Venezuela", "nationality": "Venezuelan", "phoneCode": "+58" },
  { "code": "VN", "name": "Vietnam", "nationality": "Vietnamese", "phoneCode": "+84" },
  { "code": "YE", "name": "Yemen", "nationality": "Yemeni", "phoneCode": "+967" },
  { "code": "ZM", "name": "Zambia", "nationality": "Zambian", "phoneCode": "+260" },
  { "code": "ZW", "name": "Zimbabwe", "nationality": "Zimbabwean", "phoneCode": "+263" }
];

// ==================== Country Selector ====================
export const CountrySelector = ({ value, onChange, placeholder, className, t, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredCountries = countriesData.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.phoneCode.includes(searchTerm)
  );

  const handleSelect = (country) => {
    onChange({
      target: { name: 'country', value: country.name },
      dialCode: country.phoneCode,
      nationality: country.nationality,
      code: country.code
    });
    setSearchTerm('');
    setIsOpen(false);
  };

  const selectedCountry = countriesData.find(c => c.name === value);

  return (
    <div className={`custom-select-container ${className || ''}`} ref={dropdownRef}>
      <div 
        className={`custom-select-trigger ${value ? 'has-value' : ''} ${disabled ? 'disabled' : ''}`} 
        onClick={() => !disabled && setIsOpen(!isOpen)}
        style={disabled ? { background: '#f8fafc', cursor: 'not-allowed', opacity: 0.7 } : {}}
      >
        <span>
          {value || placeholder}
          {selectedCountry && (
            <span className="selected-dial-code"> ({selectedCountry.phoneCode})</span>
          )}
        </span>
        <span className={`arrow-icon ${isOpen ? 'open' : ''}`}>▼</span>
      </div>

      {isOpen && (
        <div className="custom-select-dropdown">
          <div className="search-input-wrapper">
            <input
              type="text"
              placeholder={t ? t('search_country', 'Search country...') : 'Search country...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
              className="dropdown-search-field"
            />
          </div>
          <ul className="dropdown-options-list">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <li 
                  key={country.code} 
                  onClick={() => handleSelect(country)}
                  className={`dropdown-option-item ${value === country.name ? 'active' : ''}`}
                >
                  <span className="country-name-txt">{country.name}</span>
                  <span className="country-code-txt">{country.phoneCode}</span>
                </li>
              ))
            ) : (
              <li className="no-options-found">No countries found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

// ==================== Nationality Selector ====================
export const NationalitySelector = ({ value, onChange, placeholder, className, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // ✅ قائمة فريدة من الجنسيات (بدون تكرار)
  const uniqueNationalities = [...new Set(countriesData.map(c => c.nationality))].sort();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredNationalities = uniqueNationalities.filter(nat =>
    nat.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (nationality) => {
    onChange({
      target: { name: 'nationality', value: nationality }
    });
    setSearchTerm('');
    setIsOpen(false);
  };

  return (
    <div className={`custom-select-container ${className}`} ref={dropdownRef}>
      <div 
        className={`custom-select-trigger ${value ? 'has-value' : ''}`} 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value || placeholder}</span>
        <span className={`arrow-icon ${isOpen ? 'open' : ''}`}>▼</span>
      </div>

      {isOpen && (
        <div className="custom-select-dropdown">
          <div className="search-input-wrapper">
            <input
              type="text"
              placeholder={t ? t('search_nationality', 'Search nationality...') : 'Search nationality...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
              className="dropdown-search-field"
            />
          </div>
          <ul className="dropdown-options-list">
            {filteredNationalities.length > 0 ? (
              filteredNationalities.map((nationality, index) => (
                <li 
                  key={index} 
                  onClick={() => handleSelect(nationality)}
                  className={`dropdown-option-item ${value === nationality ? 'active' : ''}`}
                >
                  <span className="country-name-txt">{nationality}</span>
                </li>
              ))
            ) : (
              <li className="no-options-found">No nationalities found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export { countriesData };
export default CountrySelector;